import type { IndividualImageSearchRefinementResponse } from '@/api/types/Organization'
import { formatAsTitle } from './format'

export const checkImageStatus = (image: IndividualImageSearchRefinementResponse): {
  isWaiting: boolean;
  hasError: boolean;
  errorMessage: string | null;
} => {
  if (image.info?.status === 'QUEUED' || image.info?.status === 'PROCESSING') {
    return { isWaiting: true, hasError: false, errorMessage: null }
  } else if (image.info?.status === 'REJECTED' || image.info?.status === 'FAILED') {
    const errorMessage = image.info.reason.length
      ? Array.from(new Set(image.info.reason)).map(formatAsTitle).join(', ')
      : 'Unknown Error'
    return { isWaiting: false, hasError: true, errorMessage }
  }
  return { isWaiting: false, hasError: false, errorMessage: null }
}
